import {ChangeDetectionStrategy, Component} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {PatronSelectors} from '@store/patron/patron.selectors';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {ButtonRouteNameDirective} from '@lib/directives/button-route-name/button-route-name.directive';
import {IconButtonComponent} from '@aviary/buttons/icon-button/icon-button.component';
import {HiddenUntilLoadedDirective} from '@aviary/directives/hidden-until-loaded.directive';
import {MatCard, MatCardContent, MatCardTitle} from '@angular/material/card';
import {MatIcon} from '@angular/material/icon';
import {RouterTabGroupComponent} from '@lib/components/router-tab-group/router-tab-group.component';

@Component({
  selector: 'px-dependent-details',
  templateUrl: './dependent-details.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule, SelectPipe, ButtonRouteNameDirective, IconButtonComponent, HiddenUntilLoadedDirective, MatCard, MatCardTitle, MatCardContent,
    MatIcon, RouterTabGroupComponent
  ]
})
export class DependentDetailsComponent {
  public readonly selectors = PatronSelectors.DependentDetails;
}
